import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LockedList } from '../admin.interface';
import { LockedTimesheetService } from './locked-timesheet.service';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-loked-timesheet',
  templateUrl: './loked-timesheet.component.html',
  styleUrls: ['./loked-timesheet.component.css']
})

export class LokedTimesheetComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  
  public pageNumber: number = 1;                // Current page number for pagination purpose(default to 1)
  public totalElements: number = 0;             // Total data count available for pagination controls
  public selectedCheckbox: Array<any> = [];     // Single checkbox toggle variable
  public toggleInputForAll: boolean = false;    // Select all checkbox toggle
  public timesheetLock: LockedList[] = [];      // Locked timesheet list
  public originalLockedList: LockedList[] = []; // Copy of the timesheet list
  public employeeSearch: string = '';           // Search filter variable
  constructor(
    private lockedTimesheetService: LockedTimesheetService,
    private snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }

  ngOnInit() {
    this.getLockedList();
  }

  /* Upon change of pagination call API again */
  triggerChange(data: any) {
    this.pageNumber = data;
    this.getLockedList();
  }

  /* Toggle all the checkbox in the view*/
  toggleCheckbox() {
    this.timesheetLock.forEach((data) => {
      data.checked = this.toggleInputForAll;
      this.selectedCheckBox(data);
    });
  }

  /* Toggle selected checkbox */
  selectedCheckBox(row) {
    if (row.checked) { // if checked
      if (this.selectedCheckbox.indexOf(row) == -1) {
        this.selectedCheckbox.push(row);
      }
    } else { // if unchecked
      if (this.selectedCheckbox.indexOf(row) != -1) {
        this.selectedCheckbox.splice(this.selectedCheckbox.indexOf(row), 1);
      }
    }
  }

  /**
   * @function getLockefList()
   * @description
   * Function to get all the locked timesheet who have requested to unlock.
   * pagination filter has been applied with list/page set to 15
   * @argument timesheetLock The variable to store the list of the Locked time for unlock purpose
   * @argument originalLockedList The variable to hold the copy of the  timesheetLock array
   * @author gaurav.rao
   */
  getLockedList() {
    this.timesheetLock = [];
    this.spinnerService.show();
    this.lockedTimesheetService.getLockedList(this.pageNumber).subscribe((response) => {
      this.spinnerService.hide();
      this.totalElements = response.payload.LockedCount;
      if (response.payload.lockedEmplist) {
        response.payload.lockedEmplist.map(value => {
          this.timesheetLock.push(new LockedList(value));
          this.originalLockedList.push(new LockedList(value));
        });
      }
    }, 
    (error) => {
      this.spinnerService.hide();
    });
  }

  /**
   * @function unlockSelected()
   * @description
   * Function to unlock the selected requests from employee's
   * @param employee An array of employee id for API call
   * @author gaurav.rao
   */
  unlockSelected() {
    const employees = [];
    this.selectedCheckbox.map(ele => employees.push(ele.employeeId));
    if (employees.length > 0) { // if Atleast 1 request is selected
      this.lockedTimesheetService.unLockTimeSheet(employees).subscribe((response) => {
        this.snackBar.open('Unlocked selected employees Successfully', 'Okay', {
          duration: 3000,
        });
        this.getLockedList();
      }, (error) => {
        this.snackBar.open('Error occured while unlocking the timesheet', '', {
          duration: 3000
        });
      });
    }
  }

  /**
  * @function unlockAll()
  * @description
  * Function to unlock all requests from employee's
  * @author gaurav.rao
  */
  unlockAll() {
    const employees = [];
    this.lockedTimesheetService.unLockTimeSheet(employees).subscribe((response) => {
      this.snackBar.open('Unlocked All Successfully', 'Okay', {
        duration: 3000,
      });
      this.getLockedList();
    }, (error) => {
      this.snackBar.open('Error occured while unlocking the timesheet', '', {
        duration: 3000
      });
    });
  }

  /**
  * @function checkSearchData()
  * @description
  * check search data is empty and display all data 
  * @author Abhiraj
  */
  checkSearchData() {
    if (!this.employeeSearch) {
      this.applySearch();
    }
  }

  /* Search for Locked request based on Employee name */
  applySearch() {
    if (this.employeeSearch) {
      this.lockedTimesheetService.searchFilter(this.employeeSearch.trim()).subscribe((response) => {
        this.totalElements = response.payload.totalCount;
        this.timesheetLock = [];
        this.originalLockedList = [];
        response.payload.lockedList.forEach(value => {
          this.timesheetLock.push(new LockedList(value));
          this.originalLockedList.push(new LockedList(value));
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/loked-timesheet/loked-timesheet.component.ts